export type OpenSourceOS = 'android' | 'ios';

export const OPEN_SOURCE_DATA_IOS = [
  {
    name: 'Google Sign-In SDK for iOS',
    version: '7.0.0',
    description: 'Google Sign-In SDK for iOS applications',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://developers.google.com/identity/sign-in/ios',
    repository: 'https://github.com/google/GoogleSignIn-iOS',
    category: 'Authentication',
    author: 'Google Inc.',
  },
  {
    name: 'ZIPFoundation',
    version: '0.9.16',
    description: 'Effortless ZIP Handling in Swift',
    licenseType: 'MIT License',
    licenseText: `MIT License

Copyright (c) 2017-2023 Thomas Zoechling

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    homepage: 'https://github.com/weichsel/ZIPFoundation',
    repository: 'https://github.com/weichsel/ZIPFoundation',
    category: 'File Compression',
    author: 'Thomas Zoechling',
  },
  {
    name: 'Alamofire',
    version: '5.8.1',
    description: 'Elegant HTTP Networking in Swift',
    licenseType: 'MIT License',
    licenseText: `MIT License

Copyright (c) 2014-2023 Alamofire Software Foundation (http://alamofire.org/)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    homepage: 'https://github.com/Alamofire/Alamofire',
    repository: 'https://github.com/Alamofire/Alamofire',
    category: 'Networking',
    author: 'Alamofire Software Foundation',
  },
  {
    name: 'SwiftyJSON',
    version: '5.0.1',
    description: 'The better way to deal with JSON data in Swift',
    licenseType: 'MIT License',
    licenseText: `MIT License

Copyright (c) 2017 Ruoyu Fu, Pinglin Tang

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    homepage: 'https://github.com/SwiftyJSON/SwiftyJSON',
    repository: 'https://github.com/SwiftyJSON/SwiftyJSON',
    category: 'JSON Processing',
    author: 'Ruoyu Fu, Pinglin Tang',
  },
  {
    name: 'Kingfisher',
    version: '7.9.1',
    description:
      'A lightweight, pure-Swift library for downloading and caching images from the web',
    licenseType: 'MIT License',
    licenseText: `MIT License

Copyright (c) 2019 Wei Wang

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    homepage: 'https://github.com/onevcat/Kingfisher',
    repository: 'https://github.com/onevcat/Kingfisher',
    category: 'Image Loading',
    author: 'Wei Wang',
  },
  {
    name: 'SnapKit',
    version: '5.6.0',
    description: 'A Swift Autolayout DSL for iOS & OS X',
    licenseType: 'MIT License',
    licenseText: `MIT License

Copyright (c) 2011-Present SnapKit Team - https://github.com/SnapKit

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    homepage: 'https://github.com/SnapKit/SnapKit',
    repository: 'https://github.com/SnapKit/SnapKit',
    category: 'UI Layout',
    author: 'SnapKit Team',
  },
  {
    name: 'RxSwift',
    version: '6.6.0',
    description: 'Reactive Programming in Swift',
    licenseType: 'MIT License',
    licenseText: `MIT License

Copyright (c) 2015 Krunoslav Zaher

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    homepage: 'https://github.com/ReactiveX/RxSwift',
    repository: 'https://github.com/ReactiveX/RxSwift',
    category: 'Reactive Programming',
    author: 'Krunoslav Zaher',
  },
  {
    name: 'Then',
    version: '3.0.0',
    description: 'Super sweet syntactic sugar for Swift initializers',
    licenseType: 'MIT License',
    licenseText: `MIT License

Copyright (c) 2015 Suyeol Jeon (xoul.kr)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    homepage: 'https://github.com/devxoul/Then',
    repository: 'https://github.com/devxoul/Then',
    category: 'Utility',
    author: 'Suyeol Jeon',
  },
  {
    name: 'Lottie iOS',
    version: '4.3.4',
    description:
      'An iOS library to natively render After Effects vector animations',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://github.com/airbnb/lottie-ios',
    repository: 'https://github.com/airbnb/lottie-ios',
    category: 'Animation',
    author: 'Airbnb Inc.',
  },
  {
    name: 'Firebase iOS SDK',
    version: '10.18.0',
    description: 'Firebase SDK for iOS',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://firebase.google.com/docs/ios/setup',
    repository: 'https://github.com/firebase/firebase-ios-sdk',
    category: 'Backend Services',
    author: 'Google Inc.',
  },
  {
    name: 'Sentry Cocoa',
    version: '8.15.2',
    description: 'Sentry SDK for iOS/macOS/tvOS/watchOS',
    licenseType: 'MIT License',
    licenseText: `MIT License

Copyright (c) 2016 Sentry

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    homepage: 'https://docs.sentry.io/platforms/apple/',
    repository: 'https://github.com/getsentry/sentry-cocoa',
    category: 'Error Tracking',
    author: 'Sentry',
  },
  {
    name: 'SwiftLint',
    version: '0.53.0',
    description: 'A tool to enforce Swift style and conventions',
    licenseType: 'MIT License',
    licenseText: `MIT License

Copyright (c) 2015 Realm Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    homepage: 'https://github.com/realm/SwiftLint',
    repository: 'https://github.com/realm/SwiftLint',
    category: 'Development Tools',
    author: 'Realm Inc.',
  },
];

export const OPEN_SOURCE_DATA_ANDROID = [
  {
    name: 'AndroidX AppCompat',
    version: '1.6.1',
    description:
      'Android Support Library providing backward compatibility for newer Android features',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
                  you may not use this file except in compliance with the License.
                  You may obtain a copy of the License at

                  http://www.apache.org/licenses/LICENSE-2.0

                  Unless required by applicable law or agreed to in writing, software
                  distributed under the License is distributed on an "AS IS" BASIS,
                  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                  See the License for the specific language governing permissions and
                  limitations under the License.`,
    homepage:
      'https://developer.android.com/jetpack/androidx/releases/appcompat',
    repository: 'https://android.googlesource.com/platform/frameworks/support',
    category: 'UI Framework',
    author: 'Android Open Source Project',
  },
  {
    name: 'AndroidX Core',
    version: '1.9.0',
    description:
      'Core library providing access to new APIs on older Android versions',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://developer.android.com/jetpack/androidx/releases/core',
    repository: 'https://android.googlesource.com/platform/frameworks/support',
    category: 'Core Library',
    author: 'Android Open Source Project',
  },
  {
    name: 'AndroidX Activity',
    version: '1.8.0',
    description: 'Access composable APIs built on top of Activity',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage:
      'https://developer.android.com/jetpack/androidx/releases/activity',
    repository: 'https://android.googlesource.com/platform/frameworks/support',
    category: 'Activity Management',
    author: 'Android Open Source Project',
  },
  {
    name: 'AndroidX Browser',
    version: '1.6.0',
    description: "Display webpages in the user's default browser",
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://developer.android.com/jetpack/androidx/releases/browser',
    repository: 'https://android.googlesource.com/platform/frameworks/support',
    category: 'Browser Integration',
    author: 'Android Open Source Project',
  },
  {
    name: 'AndroidX Credentials',
    version: '1.2.0',
    description: 'Jetpack library for credential management APIs',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage:
      'https://developer.android.com/jetpack/androidx/releases/credentials',
    repository: 'https://android.googlesource.com/platform/frameworks/support',
    category: 'Authentication',
    author: 'Android Open Source Project',
  },
  {
    name: 'Jackson Core',
    version: '2.15.2',
    description:
      'Core part of Jackson that defines Streaming API as well as basic shared abstractions',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://github.com/FasterXML/jackson-core',
    repository: 'https://github.com/FasterXML/jackson-core',
    category: 'JSON Processing',
    author: 'FasterXML',
  },
  {
    name: 'Jackson Databind',
    version: '2.15.2',
    description:
      'General data-binding functionality for Jackson: works on core streaming API',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://github.com/FasterXML/jackson-databind',
    repository: 'https://github.com/FasterXML/jackson-databind',
    category: 'JSON Processing',
    author: 'FasterXML',
  },
  {
    name: 'OkHttp',
    version: '4.11.0',
    description:
      "Square's meticulous HTTP client for the JVM, Android, and GraalVM",
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://square.github.io/okhttp/',
    repository: 'https://github.com/square/okhttp',
    category: 'Networking',
    author: 'Square Inc.',
  },
  {
    name: 'Retrofit',
    version: '2.9.0',
    description: 'A type-safe HTTP client for Android and the JVM',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://square.github.io/retrofit/',
    repository: 'https://github.com/square/retrofit',
    category: 'Networking',
    author: 'Square Inc.',
  },
  {
    name: 'Glide',
    version: '4.15.1',
    description:
      'An image loading and caching library for Android focused on smooth scrolling',
    licenseType: 'BSD 2-Clause License',
    licenseText: `BSD 2-Clause License

Copyright (c) 2014, Sam Judd

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

1. Redistributions of source code must retain the above copyright notice, this
   list of conditions and the following disclaimer.

2. Redistributions in binary form must reproduce the above copyright notice,
   this list of conditions and the following disclaimer in the documentation
   and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.`,
    homepage: 'https://bumptech.github.io/glide/',
    repository: 'https://github.com/bumptech/glide',
    category: 'Image Loading',
    author: 'Bump Technologies',
  },
  {
    name: 'RxJava',
    version: '3.1.6',
    description:
      'Reactive Extensions for the JVM – a library for composing asynchronous and event-based programs',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://github.com/ReactiveX/RxJava',
    repository: 'https://github.com/ReactiveX/RxJava',
    category: 'Reactive Programming',
    author: 'ReactiveX',
  },
  {
    name: 'RxAndroid',
    version: '3.0.2',
    description: 'RxJava bindings for Android',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://github.com/ReactiveX/RxAndroid',
    repository: 'https://github.com/ReactiveX/RxAndroid',
    category: 'Reactive Programming',
    author: 'ReactiveX',
  },
  {
    name: 'Dagger',
    version: '2.47',
    description: 'A fast dependency injector for Java and Android',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://dagger.dev/',
    repository: 'https://github.com/google/dagger',
    category: 'Dependency Injection',
    author: 'Google Inc.',
  },
  {
    name: 'Room',
    version: '2.5.0',
    description: 'SQLite object mapping library',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://developer.android.com/jetpack/androidx/releases/room',
    repository: 'https://android.googlesource.com/platform/frameworks/support',
    category: 'Database',
    author: 'Android Open Source Project',
  },
  {
    name: 'Lottie Android',
    version: '6.1.0',
    description: 'Render After Effects animations natively on Android',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://github.com/airbnb/lottie-android',
    repository: 'https://github.com/airbnb/lottie-android',
    category: 'Animation',
    author: 'Airbnb Inc.',
  },
  {
    name: 'Firebase Android SDK',
    version: '32.3.1',
    description: 'Firebase SDK for Android',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://firebase.google.com/docs/android/setup',
    repository: 'https://github.com/firebase/firebase-android-sdk',
    category: 'Backend Services',
    author: 'Google Inc.',
  },
  {
    name: 'Sentry Android',
    version: '6.30.0',
    description: 'Sentry SDK for Android',
    licenseType: 'MIT License',
    licenseText: `MIT License

Copyright (c) 2019 Sentry

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
    homepage: 'https://docs.sentry.io/platforms/android/',
    repository: 'https://github.com/getsentry/sentry-java',
    category: 'Error Tracking',
    author: 'Sentry',
  },
  {
    name: 'Material Components for Android',
    version: '1.10.0',
    description:
      'Modular and customizable Material Design UI components for Android',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage:
      'https://github.com/material-components/material-components-android',
    repository:
      'https://github.com/material-components/material-components-android',
    category: 'UI Components',
    author: 'Google Inc.',
  },
  {
    name: 'ConstraintLayout',
    version: '2.1.4',
    description:
      'A ConstraintLayout is a ViewGroup which allows you to position and size widgets in a flexible way',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage:
      'https://developer.android.com/reference/androidx/constraintlayout/widget/ConstraintLayout',
    repository:
      'https://android.googlesource.com/platform/frameworks/opt/sherpa',
    category: 'UI Layout',
    author: 'Android Open Source Project',
  },
  {
    name: 'Gson',
    version: '2.10.1',
    description:
      'A Java serialization/deserialization library to convert Java Objects into JSON and back',
    licenseType: 'Apache License 2.0',
    licenseText: `Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
    homepage: 'https://github.com/google/gson',
    repository: 'https://github.com/google/gson',
    category: 'JSON Processing',
    author: 'Google Inc.',
  },
];
